import React from 'react';
import { Box, Typography, Paper, Container } from '@mui/material';
import BugReportIcon from '@mui/icons-material/BugReport';

function Bugs() {
  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Paper sx={{ p: 3, backgroundColor: '#1e1e1e', color: '#ffffff' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
          <BugReportIcon sx={{ mr: 2, fontSize: 28, color: '#ff9800' }} />
          <Typography variant="h4" component="h1">
            Known Issues & Bugs
          </Typography>
        </Box>
        
        <Typography variant="body1" sx={{ mb: 3, color: '#bbbbbb' }}>
          We're actively working on resolving known issues. Thank you for your patience.
        </Typography>

        <Box component="ul" sx={{ 
          '& li': { 
            mb: 1.5, 
            color: '#ffffff',
            lineHeight: 1.6
          }
        }}>
          <li>We are working with our data vendor to bring Bet365 Online</li>
          <li>We are working with our data vendor to resolve unavailable lines being shown for PrizePicks</li>
          <li>We are working with our data vendor to resolve limited instances of Pinnacle, FanDuel, and BetMGM markets that have been removed from the book continuing to be displayed in our feed</li>
          <li>We are working internally on bringing Underdog pickem back online with multipliers accounted for</li>
        </Box>

        <Box sx={{ mt: 4, pt: 3, borderTop: '1px solid #444' }}>
          <Typography variant="body2" sx={{ color: '#999999', mt: 1 }}>
            Found a bug? Please report it on our{' '}
            <a 
              href="https://discord.gg/4for4" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{ color: '#4fc3f7', textDecoration: 'none' }}
            >
              Discord
            </a>
            {' '}in the #sharpstack-chat channel.
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
}

export default Bugs;